import layoutMap from '../layoutMap';
import questionTypes from '../questionTypes';
import createEmptyOptionCollection from '../../utils/createEmptyOptionCollection';
import getCommonBlockProps, { commentsProps } from './getCommonBlockProps';
import { imageSizeType } from './settings/imageSizeList';
import { labelLayout } from './settings/labelLayoutList';
import personalLabelMap from '../personalLabelMap';
import { DEFAULT_ROW_LABEL } from './constants';
import { STYLING_KEY_QUESTION_TEXT } from '../../constants/stylingKey';

export default {
  type: questionTypes.questionImageMulti,
  getDefaultProps: () => ({
    ...getCommonBlockProps(),
    ...commentsProps,
    size: imageSizeType.small,
    personalLabelType: personalLabelMap.noLabel,
    layout: layoutMap.horizontal,
    labelLayout: labelLayout.topLeft,
    options: createEmptyOptionCollection(2, DEFAULT_ROW_LABEL),
  }),
  limits: {
    options: {
      max: 52, // do not change in one place - calculating IE fix - search for 'ie-vertical-grid-item-position' mixin @sinslav
      min: 2,
    },
  },
  settings: {
    defaultStylingEntity: STYLING_KEY_QUESTION_TEXT,
    isRequiredField: () => false,
    isUniqueField: () => false,
    isTextRequired: () => true,
  },
  toLogicOptions: questions =>
    questions.options.map(option => ({
      value: option.id,
      label: option.value,
      imageSrc: option.src,
    })),
};
